import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ICaseSecuritySummary } from 'src/app/shared/models';

@Component({
  selector: 'app-case-securities',
  templateUrl: './securities.component.html',
  styleUrls: ['./securities.component.scss'],
  imports: [CommonModule, TranslateModule, TableModule]
})
export class SecuritiesComponent {

  @Input() list: ICaseSecuritySummary[];
}
